@if (pwaUpdate.updateAvailable()) {
<div class="update-notice" role="status" aria-live="polite">
  <div class="update-notice__icon">
    <i class="fa-solid fa-rotate" [class.fa-spin]="isUpdating()"></i>
  </div>
  <div class="update-notice__body">
    <span class="update-notice__title">Nueva versión disponible</span>
    <span class="update-notice__text">Guarde sus cambios antes de actualizar.</span>
    <button type="button" class="update-notice__btn" [disabled]="isUpdating()" (click)="update()">
      {{ isUpdating() ? 'Actualizando...' : 'Actualizar ahora' }}
    </button>
  </div>
</div>
}
